<!-- Home.vue -->
<template>
  <div>
    <v-carousel :height="carouselHeight" :key="carouselKey">
      <v-carousel-item
        v-for="(banner, index) in banners"
        :key="index"
        :src="getResponsiveImage(banner)"
      >

      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data() {
    return {
      baseUrl: 'https://api.skintock.com',
      banners: [],
      windowWidth: window.innerWidth,
      carouselKey: 0, // 변경 시 재렌더링됨
    }
  },
  computed: {
    carouselHeight() {
      if (this.windowWidth < 600) {
        return 600 // 모바일
      } else if (this.windowWidth < 1280) {
        return 800 // 태블릿
      } else {
        return 800 // 데스크탑
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.getMainImages()
    window.addEventListener('resize', this.handleResize)
  },
  methods:{
    getMainImages(){
      axios.get('https://api.skintock.com/api/main-banner/images/')
      .then(res=>{
        this.banners = res.data
        console.log(res.data)
      })
    },
    getResponsiveImage(banner) {
      if (this.windowWidth < 600) {
        return `${this.baseUrl}${banner.image_mobile}`
      } else if (this.windowWidth < 1000) {
        return `${this.baseUrl}${banner.image_tablet}`
      } else {
        return `${this.baseUrl}${banner.image_desktop}`
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      this.carouselKey++ // 캐러셀 강제 재생성
    },
  }
}
</script>

<style scoped>
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
